import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useGlobalSettings } from "@/hooks/useCMSContent";
import { useWhitelabel } from "@/contexts/WhitelabelContext";

export const GlobalHeadManager = () => {
  const { data: settings } = useGlobalSettings();
  const { isWhitelabel, brandName, whitelabel } = useWhitelabel();

  useEffect(() => {
    // Whitelabel favicon is handled by WhitelabelContext
    // Only apply global settings favicon if not whitelabel
    if (!isWhitelabel && settings?.branding?.favicon_url) {
      const link: HTMLLinkElement = 
        document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = settings.branding.favicon_url;
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  }, [settings?.branding?.favicon_url, isWhitelabel]);

  if (!settings) return null;

  // Use whitelabel brand name if available
  const siteName = isWhitelabel ? brandName : (settings.app_name || "Work IA");
  const siteTitle = isWhitelabel 
    ? `${brandName} - Sistema de Gestão Inteligente`
    : (settings.site_title || `${siteName} - Sistema de Gestão Inteligente`);
  const siteDescription = settings.site_description || "Sistema de gestão inteligente para pequenos negócios";
  const siteKeywords = settings.site_keywords || "sistema de gestão, CRM, agendamento, IA";
  const ogImage = settings.branding?.og_image_url || "https://www.workia.com.br/og-image.png";

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />
      <meta name="author" content={siteName} />
      
      {/* Open Graph */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};